import TRANSLATE_EN from "./en/translations.json";
import TRANSLATE_PL from "./pl/translations.json";

export const translations = {
  en: { translation: TRANSLATE_EN },
  pl: { translation: TRANSLATE_PL },
};
